import React from 'react';
import { st, classes } from './StarsRatingBar.st.css';
import { dataHooks, starValues } from '../constants';

import { FavoriteFilled } from '@wix/wix-ui-icons-common';
import { semanticClassNames } from '../StarsRatingBar.semanticClassNames';
import { StarsRatingBarProps } from '../StarsRatingBar.types';
import { getRatingLabel, getStarSizePx } from '../utils/common';
import { useIcons } from '../../WixDesignSystemIconThemeProvider';

export const ReadOnlyStarsRatingBar = (props: StarsRatingBarProps) => {
  const { dataHook, className, value = 0 } = props;
  const sizePx = getStarSizePx(props);
  const icons = useIcons('ReadOnlyStarsRatingBar', { FavoriteFilled });

  return (
    <div
      data-hook={dataHook}
      className={st(classes.root, { readOnly: true }, className)}
    >
      <div
        role="img"
        aria-label={getRatingLabel(props, value)}
        className={classes.starsContainer}
      >
        {starValues.map(starValue => {
          const filled = value >= starValue;

          return (
            <div
              key={starValue}
              data-hook={filled ? dataHooks.filledStar : dataHooks.emptyStar}
              data-index={starValue}
              className={st(classes.starContainer, semanticClassNames.button)}
            >
              <icons.FavoriteFilled
                aria-hidden
                className={st(
                  classes.star,
                  { filled },
                  filled
                    ? semanticClassNames.filledIcon
                    : semanticClassNames.emptyIcon,
                )}
                size={sizePx}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
